/**
 * bill模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const bill = {
	//资源服务运营报告
	getBillStatistics(params) {
		return $http.post(`${global.API_URL}/sme/bill/getBillStatistics`,params);
	}
}

export default bill;



// WEBPACK FOOTER //
// ./src/api/bill.js